module.exports = __webpack_public_path__ + "static/media/bca64b0f.jpg";